<template>
  <v-dialog
    v-model="dialogMultiplication"
    width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        class="v-btn--multiplication px-6"
        :color="color"
        v-on="on">
        <v-icon>$vuetify.icons.layerPlus</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{ type }} x
        <v-input>
          <v-text-field
            id="creditsInput"
            v-model.number="amount"
            :label="$vuetify.lang.t('$vuetify.ecoDetail.input')"
            type="number"
            min="0"
            max="10000"
            singleLine
            hideDetails
            class="v-input--multiplication"
            :disabled="is_screen_tablet" />
        </v-input>
        <!-- =
        {{ type * amount }} -->
      </v-card-title>

      <section class="numberpad numberpad--multiplication mt-4">
        <v-btn
          color="black"
          class="v-btn--superLarge"
          @click="append(7)">
          <span>7</span>
        </v-btn>
        <v-btn
          color="black"
          class="v-btn--superLarge"
          @click="append(8)">
          <span>8</span>
        </v-btn>
        <v-btn
          color="black"
          class="v-btn--superLarge"
          @click="append(9)">
          <span>9</span>
        </v-btn>

        <v-btn
          color="black"
          class="v-btn--superLarge"
          @click="append(4)">
          <span>4</span>
        </v-btn>
        <v-btn
          color="black"
          class="v-btn--superLarge"
          @click="append(5)">
          <span>5</span>
        </v-btn>
        <v-btn
          color="black"
          class="v-btn--superLarge"
          @click="append(6)">
          <span>6</span>
        </v-btn>

        <v-btn
          color="black"
          class="v-btn--superLarge"
          @click="append(1)">
          <span>1</span>
        </v-btn>
        <v-btn
          color="black"
          class="v-btn--superLarge"
          @click="append(2)">
          <span>2</span>
        </v-btn>
        <v-btn
          color="black"
          class="v-btn--superLarge"
          @click="append(3)">
          <span>3</span>
        </v-btn>

        <v-btn
          color="black"
          class="v-btn--superLarge extraBigIcon"
          @click="del">
          <v-icon>$vuetify.icons.backspace</v-icon>
        </v-btn>
        <v-btn
          color="black"
          class="v-btn--superLarge"
          @click="append(0)">
          <span>0</span>
        </v-btn>
        <v-btn
          color="success"
          class="v-btn--superLarge extraBigIcon"
          :disabled="amount===0"
          @click="send()">
          <v-icon>$vuetify.icons.check</v-icon>
        </v-btn>
      </section>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CreditsMultiplication',

  props: {
    type: Number,
    color: {
      type: String,
      default: 'primary',
    },
  },

  data() {
    return {
      dialogMultiplication: false,
      amount: null,
    };
  },

  computed: {
    is_screen_tablet() {
      return this.$vuetify.breakpoint.smAndUp
    },
  },

  methods: {
    /**
     * Adding credits to the text area after clicking on the numeric keypad. (number = 5, credits = 15 => append(5) = 115)
     * @param {number} number - The number I add after the number in the input.
     */
    append(number) {
      this.amount = Number('' + (this.amount == null ? "" : this.amount) + number);
    },

    del() {
      this.amount = this.amount / 10 ^ 0;
    },

    send() {
      for(var i = 0; i < this.amount; i++){
        this.$emit("callParentFunction");
      }

      this.amount = null;
      this.dialogMultiplication = false;
    },
  },
};
</script>

<style lang="scss">
.numberpad--multiplication {
  display: grid !important;

  padding: 1rem;
}

.v-input--multiplication {
  margin-bottom: -1.1rem;
  padding: 0 0.5rem;

  .v-text-field__slot {
    padding: 0;

    input {
      font-size: 1.5rem;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        appearance: none;
        margin: 0;
      }

      &:disabled {
        color: rgba(0, 0, 0, 0.87);
      }
    }
  }
}
</style>
